import React from 'react';

export class SocialLinks extends React.Component {
  render() {
    return (
     
         <div className="col-md-5 col-sm-5 col-xs-12">
            <ul id="footer-social-link">
              <li><a href="https://www.facebook.com/Hapiwine/" target="_blank"><img src="images/rs_fb.png"/></a> </li>
              <li><a href="https://twitter.com/Hapiwine" target="_blank"><img src="images/rs_twitter.png"/></a> </li>
              <li><a href="https://www.instagram.com/hapiwineapp/" target="_blank"><img src="images/rs_insta.png"/></a> </li>
              
            </ul>
            <ul className="visible-xs btm-mail-link">
              <li><a href="mailto:contact@hapiwine.fr">contact@hapiwine.fr</a> </li>
            </ul>
          </div>
     
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer/SocialLinks/SocialLinks.js